import { IDeleteControleResiduoUseCase } from "../../../presentation/useCases/delete/delete_controle_residuo_use_case";
import { DeleteControleResiduoRequestModel, DeleteControleResiduoResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteControleResiduoUseCase
 */

export class DeleteControleResiduoUseCase implements IDeleteControleResiduoUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteControleResiduo(model: DeleteControleResiduoRequestModel): Promise<DeleteControleResiduoResponseModel> {
    return await this.repository.deleteControleResiduo(model);
  }
}
